// @Vendors
import React from 'react';
import { connect } from 'react-redux';
import { Route, Redirect } from 'react-router-dom';
import { setCookie } from '../../../utils/session';

// @State
import { selectIsAuthenticated, selectUserLogged } from '../../../state/auth/auth.selectors';

// @Template
import PageTemplate from '../Templates/PageTemplate';

const PrivateRoute = ({ component: Component, ...rest }) => {
  setCookie('redirect', rest.location.pathname);
  return (
    <Route {...rest} render={(props) => (
      rest.isAuthenticated !== null
        ? rest.isAuthenticated
          ? (
            <PageTemplate>
              <Component {...props} />
            </PageTemplate>
          )
          : <Redirect to='/login' />
        : null
    )} />
  )
};

const mapStateToProps = state => ({
  isAuthenticated: selectIsAuthenticated(state),
  userLogged: selectUserLogged(state),
});

const actions = {};

export default connect(
  mapStateToProps,
  actions
)(PrivateRoute);



// WEBPACK FOOTER //
// ./src/pages/App/Routes/PrivateRoute.js